import React from "react";
import { List, Typography } from "@material-ui/core";

import { useActionStyles } from "./workOrderAction";

export const FormSection = (props) => {
    const classes = useActionStyles();

    return (
        <>
            <Typography className={classes.sectionHeader}>
                {props.isMandatory ? <span style={{ color: "red" }}>*</span> : null}
                {props.title}
            </Typography>
            <div className={classes.paper}>
                <List className={classes.list}>{props.children}</List>
            </div>
        </>
    );
};

export default FormSection;
